module.exports = __webpack_public_path__ + "img/fh_slider6.0464f132.jpg";